<template>
    <div class="ppv2-bg-white dark:ppv2-bg-dark ppv2-rounded-3xl ppv2-p-6">
        <Header :title="$t('promotions.title_promotion')" />
        <bo-marketing-promotion-table @edit="goToEdit" :token="token" />
    </div>
</template>

<script>
import normalizeSize from '../../../../utils/normalizeSize'
import normalizeFontSize from '../../../../utils/normalizeFontSize'
import Header from '../../../Shared/Header.vue'
export default {
    name: 'PromotionIndex',
    components: {
        Header,
    },
    props: {
        userId: {
            type: [Number, String],
            default: null,
        },
        token: {
            type: [String],
            default: '',
        },
    },
    methods: {
        normalizeFontSize,
        goToCreate() {
            // Use Turbo to visit the create page
            window.Turbo.visit('/back-office/v3/promotions/create')
        },
        goToEdit(id) {
            window.Turbo.visit(`/back-office/v3/promotions/${id}/edit`)
        },
        normalizeSize,
    },
}
</script>
